import Input from "../components/Input";
import SettingAction from "./SettingAction";
import { ContentTypes, DialogTypes } from "../constants/action-types";
import GridAction from "../actions/GridAction";
import PlusIcon from "../icons/Plus";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { renderFieldIcon } from "../fields/FieldList";

const GridColumnSetting = ({ contentType, fields, hiddenColumns, onSelectColumn }) => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");

  const renderHiddenColumns = () => {
    const filteredFields = hiddenColumns.filter((item) => {
      const name = item.get("name") || "";
      if (name.toUpperCase().search(searchValue.toUpperCase()) !== -1) {
        return true;
      }
    });
    const renderedFields = searchValue ? filteredFields : hiddenColumns;

    return renderedFields.map((col) => {
      const field = fields.find((item) => item.get("id") === col.get("selector")) || {};
      return (
        <li
          key={`${col.get("selector")}`}
          className={"flex p-2 gap-1 items-center cursor-pointer text-gray-600 hover:text-blue-600"}
          onClick={() => {
            onSelectColumn({ ...col.toJS(), show: true });
            setSearchValue("");
          }}
        >
          {renderFieldIcon(field.toJS())}
          {col.get("name")}
        </li>
      );
    });
  };

  const renderAddCustomField = () => {
    if (contentType === ContentTypes.ACTIVITY) {
      return null;
    }
    return (
      <div
        className={
          "w-full bg-gray-50 text-blue-600 h-10 space-x-2 flex items-center cursor-pointer px-2"
        }
        onClick={() => {
          dispatch(
            GridAction.showGridDialog(undefined, DialogTypes.createCustomFieldDialog, contentType)
          );
        }}
      >
        <PlusIcon size={20} />
        New field
      </div>
    );
  };
  return (
    <SettingAction>
      <ul className={"list-none"}>
        {renderAddCustomField()}
        <div className={" p-2 w-full"}>
          <Input
            placeholder="Search field"
            value={searchValue}
            onChange={(value) => {
              setSearchValue(value);
            }}
          />
        </div>
      </ul>
      <ul className={"list-none overflow-y-auto"} style={{ maxHeight: 600 }}>
        {renderHiddenColumns()}
      </ul>
    </SettingAction>
  );
};

export default GridColumnSetting;
